import React, { useState, useEffect, useRef } from "react";
import "./Select.css";

function Select(props) {
  const [selectOptions, setSelectOptions] = useState(props.selectOptions);
  const [selectActive, setSelectActive] = useState(false);
  const [selectValue, setSelectValue] = useState(props.initVal ? props.initVal : "");
  const [selectSearch, setSelectSearch] = useState("");
  const selectRef = useRef("");

  useEffect(() => {
    setSelectValue(props.initVal);
  }, [props.initVal]);

  useEffect(() => {
    setSelectOptions(props.selectOptions);
  }, [props.selectOptions]);

  const openCloseSelect = () => {
    setSelectActive(!selectActive);
    if (selectActive && (props.selectSearch || props.externalSearch)) {
      setSelectSearch(""); 
    }
  };

  const updateSelectState = (val, key) => {
    setSelectSearch("");
    setSelectValue(val);
    setSelectActive(false);
    if (props.selectCallback && props.callBackValue) {
      if (key || key === 0) {
        props.selectCallback(props.callBackValue, key);
      } else {
        props.selectCallback(props.callBackValue, val);
      }
    }
  };

const handleSelectSearch = (e) => {
  e.stopPropagation();
  const val = e.target.value;
  setSelectSearch(val);

  if (props.selectSearch) {
    setSelectOptions(
      props.selectOptions.filter((opt) =>
        opt.value.toLowerCase().includes(val.toLowerCase())
      )
    );
  } else if (props.externalSearch) {
    if (val && val.length >= 3) {
      props.externalSearch(val);
    } else if (val === "") {
      props.externalSearch(val);
    }
  }
};

  function useOutsideSelect(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setSelectActive(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  useOutsideSelect(selectRef);
  
  const searchInputRef = useRef(null);
  useEffect(() => {
  if (selectActive && (props.selectSearch || props.externalSearch)) {
    setTimeout(() => {
      searchInputRef.current?.focus();
    }, 0); 
  }
}, [selectActive]);

  return (
    <div
      className={
        props.selectError &&
        (!selectValue ||
          selectValue === "Select Exercise" ||
          selectValue === "Reps")
          ? " prog_err_input"
          : ""
      }
      ref={selectRef}
    >
      <div
        className={
          "select_main" +
          (selectActive &&
          (selectOptions.length > 0 ||
            props.selectSearch ||
            props.externalSearch) &&
          !props.inQuestionare
            ? " select_main_active"
            : selectActive && props.inQuestionare
            ? " select_main_active_questionaire"
            : !selectValue && props.inExerciseBuild
            ? " select_active_drop_length"
            : selectValue && props.inExerciseBuild
            ? " select_nonactive_drop_length"
            : "") +
          (props.disabled ? " select_main_disabled" : "")
        }
        onClick={openCloseSelect} 
      >
        {props.externalSearch && !selectValue && (
          <div>
            {selectSearch && selectSearch.length > 0 && (
              <div className="select_placeholder oi_el_placehold sp_act">
                Patient Name
              </div>
            )}
            <input
              type="text"
              value={selectSearch}
              placeholder={
                props.selectSearchPlacehold ? props.selectSearchPlacehold : ""
              }
              className={
                selectSearch.length < 1
                  ? "select_search select_external_search"
                  : "select_search_for_name select_external_search_for_name"
              }
              onChange={handleSelectSearch} // Updated: pass event object directly
              onClick={(e) => e.stopPropagation()} // <--- CRITICAL FIX: Stop click propagation
            />
          </div>
        )}
        <div className="select_values_contain">
          {!(props.emptyErrorField && props.selectError) && (
            <div
              className={
                "select_placeholder" + (selectValue ? " sp_act" : " sp_inact")
              }
            >
              {props.noPlaceholdAfterValue && selectValue
                ? ""
                : props.placeholder}
            </div>
          )}
          <div
            className={
              "selected_value" +
              (props.emptyErrorField && props.selectError ? " sp_inact" : "")
            }
          >
            {props.emptyErrorField && props.selectError
              ? props.placeholder
              : selectValue}
          </div>
        </div>
        <div
          className={
            "select_main_arrow" +
            (props.disabled ? " select_arrow_disabled" : "")
          }
        ></div>
      </div>
      <div
        className={
          "options_hold " +
          ( props.useHeight == true ? "options_hold_small " : " ") +
          ( selectActive ? " options_is_selected " : " options_is_notselected ") +
          (selectActive && (selectOptions.length > 0 || props.selectSearch || props.externalSearch ) && !props.inQuestionare && !props.inSettings ? " oh_enabled" :
			selectActive && props.inQuestionare ? " oh_enabled_questionaire" :
			props.useHeight == true ? " oh_enabled oh_min_height " :
			selectActive && props.inSettings ? " oh_enabled_settings" : " oh_disabled")
        }
      >
        {props.selectSearch && (
          <input
            type="text"
            value={selectSearch}
            placeholder={
              props.selectSearchPlacehold ? props.selectSearchPlacehold : ""
            }
            ref={searchInputRef}
            className="select_search"
            onChange={handleSelectSearch}
            onClick={(e) => e.stopPropagation()}
			tabIndex={props.useTabIndex || ""}
			onFocus={(e) => { if ( props.useHeight == true ) { setSelectActive(true); } }}
			onBlur={(e) => { if ( props.useHeight == true ) { setTimeout(() => { setSelectActive(false); }, 200); } }}
          />
        )}
        <div className="oh_sub_options">
        {selectOptions.length > 0 ? (
          selectOptions
            .filter((option) => {
              if (props.selectSearch && selectSearch) {
                return option.value
                  .toLowerCase()
                  .startsWith(selectSearch.toLowerCase());
              }
              return true;
            })
            .map((option, i) => (
              <div
                key={option.value || i} 
                className="oh_option"
                onClick={() =>
                  updateSelectState(
                    option.value,
                    option.key || option.key === 0 ? option.key : ""
                  )
                }
              >
                {option.value || props.selectSearchEmptyString}
              </div>
            ))
        ) : (
          <div className="oh_option option_no_res">No results found.</div>
        )}
        </div>
      </div>
    </div>
  );
}

export default Select;